<div class="main-container">
    <p class="error-status">
        <span>Error: </span>
        <span>{{errorStatus}}</span>
    </p>
    <p class="error-message">{{errorMessage}}</p>
</div>